import { combineReducers } from 'redux'
import PricesByDoctorReducer from './pricelist.prices.bydoctor.reducer'
import PricesByServiceReducer from './pricelist.prices.byservice.reducer'

const PricelistPricesReducer = combineReducers({
  byservice: PricesByServiceReducer,
  bydoctor: PricesByDoctorReducer,
})

export default PricelistPricesReducer